import { IsFlagActive } from '@rover/rsdk/src/modules/Data/Core/FrontendConfiguration';

import useFrontendConfigurationShim from './useFrontendConfigurationShim';

export { FLAGS } from '@rover/rsdk/src/modules/Data/Core/FrontendConfiguration';

const useFlag: IsFlagActive = (flag, defaultValue) => {
  const { isFlagActive } = useFrontendConfigurationShim();
  return isFlagActive(flag, defaultValue);
};

export default useFlag;
